exports.components = {
  "component---src-templates-404-template-tsx": () => import("./../../../src/templates/404Template.tsx" /* webpackChunkName: "component---src-templates-404-template-tsx" */),
  "component---src-templates-doc-template-tsx": () => import("./../../../src/templates/DocTemplate.tsx" /* webpackChunkName: "component---src-templates-doc-template-tsx" */)
}

